import React, { useState,useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../components/pages/Home'; 
import TermsCondition from './pages/TermsCondition';
import '../assets/css/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import "../i18n";
import { useTranslation } from 'react-i18next';


function AppWrapper() {
     const { i18n } = useTranslation();

     useEffect(() => {
            if (i18n.language === 'ar') {
              document.body.style.direction = 'rtl';
            }else{
              document.body.style.direction = 'ltr';
            }
     },[i18n.language])
   
    return(
    <Router>
      <Routes>
        <Route exact path="/" element={<Home/>} />
        <Route path="terms&condition" element={<TermsCondition/>}/>
      </Routes>
    </Router>
  );
}

export default AppWrapper;